export default "__VITE_ASSET__4b12cbbe__"